/**
 * @flow
 * @relayHash 0e83aa77aa63a1c072cebe5d32f14a2a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserDeleteInput = {
  id: string
};
export type UserDeleteMutationVariables = {|
  input: UserDeleteInput
|};
export type UserDeleteMutationResponse = {|
  +UserDelete: ?{|
    +error: ?string
  |}
|};
export type UserDeleteMutation = {|
  variables: UserDeleteMutationVariables,
  response: UserDeleteMutationResponse,
|};
*/


/*
mutation UserDeleteMutation(
  $input: UserDeleteInput!
) {
  UserDelete(input: $input) {
    error
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserDeleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UserDeleteInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "error",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserDeleteMutation",
  "id": null,
  "text": "mutation UserDeleteMutation(\n  $input: UserDeleteInput!\n) {\n  UserDelete(input: $input) {\n    error\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "UserDelete",
        "storageKey": null,
        "args": v1,
        "concreteType": "UserDeletePayload",
        "plural": false,
        "selections": [
          v2
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserDeleteMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "UserDelete",
        "storageKey": null,
        "args": v1,
        "concreteType": "UserDeletePayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cab7213e6d5b413ff41e385b1fa451ba';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/UserDeleteMutation.graphql.js